import { render, staticRenderFns } from "./NewCourse.vue?vue&type=template&id=5053e352&scoped=true"
import script from "./NewCourse.vue?vue&type=script&lang=js"
export * from "./NewCourse.vue?vue&type=script&lang=js"
import style0 from "./NewCourse.vue?vue&type=style&index=0&id=5053e352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5053e352",
  null
  
)

export default component.exports